import th from 'i18n/locales/th';
import en from 'i18n/locales/en';
import ko from 'i18n/locales/ko';
import id from 'i18n/locales/id';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LocalStorageBackend from 'i18next-localstorage-backend';

i18n
  .use(LocalStorageBackend)
  .use(initReactI18next)
  .init({
    resources: {
      en,
      ko,
      th,
      id,
    },
    fallbackLng: 'th',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      backendOptions: {
        prefix: 'lang',
      },
    },
  });

export default i18n;
